// extracted by mini-css-extract-plugin
export default {"fullWidth":"No-z","image":"Oo-z","lazyLoadPicture":"Po-z","lazyLoadSpinner":"Qo-z","lazyLoadSpin":"Ro-z","lazyLoadImage":"So-z","hasStyledAspectRatio":"To-z"};